export default "__VITE_ASSET__BAZIT4cd__"